import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { loadAllWlf } from '../SA_Wlf/actions';
import WhiteLabelFirmsData from './components/WhiteLabelFirmsData';
import './styles.css';

export const DATA_TYPE = Object.freeze({
    CURRENCY: 'CURRENCY',
    PHONE: 'PHONE',
    ADVISORY: 'ADVISORY',
    SUB_ADVISORY: 'SUB_ADVISORY',
    DEFAULT: 'DEFAULT'
})

const columns = [
    { header: 'White Label Firm', key: 'name'} ,
    { header: 'Phone', key: 'info.phone' },
    { header: 'Address', key: 'info.address' },
    { header: 'Advisory Fee', key: 'advisory_fee' },
    { header: 'Sub Advisory Fee', key: 'sub_advisory_fee' },
    { header: 'Total Balance', key: 'total' },
    // { header: 'Disclosures', key: '' },
    // { header: 'Online Privacy', key: '' },
    // { header: 'Terms and Conditions', key: '' },
    // { header: 'CSS', key: '' }
]

const getValue = (obj, path) => {
    const value = path.split('.').reduce((acc, key) => acc[key], obj);

    // If the final value is an array of strings, join it
  return Array.isArray(value) && value.every(item => typeof item === 'string') ? value.join(', ') : value;
  }

const WhiteLabelFirmsTable = () => {
    const [wlfItems, setWlfItems] = useState([])
    // eslint-disable-next-line no-unused-vars
    const [isLoading, setIsLoading] = useState(true);
    const token = useSelector(state => state.user.token);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const { wlfs } = await loadAllWlf(token);
                setWlfItems(wlfs);
            } catch (error) {
                console.log(error);
            } finally {
                setIsLoading(false);
            }
        }
        fetchData();

    }, [])

    return (
        <div className='white-label-firms-table-container' style={{ display: 'flex' }}>
            <table className='white-label-firms-table' style={{ flex: '1 1 auto' }}>
                <thead className='white-label-firms-header'>
                    <tr className='white-label-firms-rows'>
                        {columns.map(({header}) => (
                            <th key={header}>{header}</th>
                        ))}
                    </tr>
                </thead>
                <tbody className='white-label-firms-body'>
                    {wlfItems.map((wlf) => (
                        <tr key={wlf.id} className='white-label-firms-rows' >
                            {columns.map(({header, key}) => {
                                let dataType = DATA_TYPE.DEFAULT;

                                if(key === 'total') {
                                    dataType = DATA_TYPE.CURRENCY;
                                } else if (key === 'advisory_fee') {
                                    dataType = DATA_TYPE.ADVISORY;
                                } else if (key === 'sub_advisory_fee') {
                                    dataType = DATA_TYPE.SUB_ADVISORY;
                                } else if (key === 'info.phone') {
                                    dataType = DATA_TYPE.PHONE;
                                }

                                
                                return (
                                    <td key={header}>
                                        <WhiteLabelFirmsData dataType={dataType} data={getValue(wlf, key)} wlfId={wlf.id} />
                                    </td>
                                )
                            })}
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    )
}

export default WhiteLabelFirmsTable